<template>
  <v-data-table
    :headers="headers"
    :items="respuesta_empleado"
    sort-by="calories"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Respuestas</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>

        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
              Nueva respuesta
            </v-btn>
          </template>

          <v-card>
            <v-card-title>
              <span class="text-h5">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="8" md="9">
                    <v-text-field
                      v-model="editedItem.respuesta"
                      label="Respuesta"
                    ></v-text-field>
                  </v-col>

                  <!-- evaluacion add -->
                  <v-col cols="12" sm="8" md="8">
                    <v-autocomplete
                      v-model="pregunta"
                      :items="preguntas"
                      label="Selecciona una pregunta"
                      persistent-hint
                      prepend-inner-icon="mdi-school"
                      hide-details
                      return-object
                      item-text="pregunta"
                      item-value="idpregunta"
                    >
                    </v-autocomplete>
                  </v-col>

                  <!-- usuario add -->
                  <v-col cols="12" sm="8" md="8">
                    <v-autocomplete
                      v-model="empleado"
                      :items="empleados"
                      label="Selecciona un empleado"
                      persistent-hint
                      prepend-inner-icon="mdi-account"
                      hide-details
                      return-object
                      item-text="nombre_completo"
                      item-value="id_usuario"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">
                Cancelar
              </v-btn>
              <v-btn color="blue darken-1" text @click="save">
                Guardar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5"
              >¿Estás seguro de eliminar este elemento?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Cancelar</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">
        mdi-pencil
      </v-icon>
      <v-icon small @click="deleteItem(item)">
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">
        Reset
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
export default {
  data: () => ({
    pregunta: null,
    preguntas: [],
    empleado: null,
    empleados: [],
    dialog: false,
    dialogDelete: false,
    headers: [
      { text: "Respuesta", value: "respuesta" },
      { text: "Pregunta", value: "pregunta" },
      { text: "Número pregunta", value: "numero_pregunta" },
      { text: "Autoevaluable", value: "autoevaluable" },
      { text: "Valor", value: "valor" },
      { text: "Empleado", value: "idempleado" },
      { text: "Evaluación", value: "idevaluacion" },
      { text: "Pregunta", value: "idpregunta" },
      { text: "Tipo pregunta", value: "idtipo_pregunta" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    respuesta_empleado: [], //arreglo
    editedIndex: -1,
    editedItem: {
      //agrego cada campo a utlizar
      idrespuesta_empleado: 0,
      respuesta: "",
      pregunta: "",
      numero_pregunta: 0,
      valor: 0,
      autoevaluable: 0,
      idempleado: 0,
      idevaluacion: 0,
      idtipo_pregunta: 0,
      idpregunta: 0,
      usuario_registro: 0,
      fecha_creacion: null,
      fecha_actualizo: null,
      deleted: 0,
    },
    defaultItem: {
      idrespuesta_empleado: 0,
      respuesta: "",
      pregunta: "",
      numero_pregunta: 0,
      valor: 0,
      autoevaluable: 0,
      idempleado: 0,
      idevaluacion: 0,
      idtipo_pregunta: 0,
      idpregunta: 0,
      usuario_registro: 0,
      fecha_creacion: null,
      fecha_actualizo: null,
      deleted: 0,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva respuesta" : "Editar respuesta";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
    // Generando la fecha de hoy
  },

  methods: {
    initialize() {
      this.empleados = [];
      this.$http
        .get("usuarios.all.erp")
        .then((responseUsuarios) => {
          for (const i in responseUsuarios.body) {
            responseUsuarios.body[i].nombre_completo = responseUsuarios.body[
              i
            ].nombre_completo.toUpperCase();
          }
          this.empleados = responseUsuarios.body;
        })
        .catch((error) => {
          console.log(error);
        });

      this.$http
        .get("preguntas.all")
        .then((responseTipo) => {
          this.preguntas = responseTipo.body;
        })
        .catch((error) => {
          console.log(error);
        });

      this.$http
        .get("respuestas.all")
        .then((responserespuesta_empleado) => {
          this.respuesta_empleado = responserespuesta_empleado.body;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    editItem(item) {
      this.editedIndex = this.respuesta_empleado.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.respuesta_empleado.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.respuesta_empleado.splice(this.editedIndex, 1);
      //"Borrando"
      var datos = {
        pregunta: this.editedItem.pregunta,
        idcurso: this.editedItem.idcurso,
        usuario_registro: 1,
        deleted: 1,
      };
      this.$http
        .put("respuestas.update/" + this.editedItem.idrespuesta_empleado, datos)
        .then((response) => {
          this.initialize();
        })
        .catch((error) => console.log(error));

      console.log(this.editedItem.idrespuesta_empleado + " borrar");
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      //recibe los campos del form
      console.log(this.editedItem);

      //guardo en una variable los datos a guardar id = this.editedItem.idcurso;

      var datos = {
        respuesta: this.editedItem.respuesta,
        idpregunta: this.pregunta.idpregunta,
        pregunta: this.pregunta.pregunta,
        numero_pregunta: this.pregunta.numero_pregunta,
        valor: this.pregunta.valor,
        autoevaluable: this.pregunta.autoevaluable,
        idevaluacion: this.pregunta.idevaluacion,
        idtipo_pregunta: this.pregunta.idtipo_pregunta,
        idempleado: this.empleado.id_usuario,
        usuario_registro: 1,
        deleted: 0,
      };

      if (this.editedIndex > -1) {
        this.$http
          .put(
            "respuestas.update/" + this.editedItem.idrespuesta_empleado,
            datos
          )
          .then((response) => {
            this.initialize();
          })
          .catch((error) => console.log(error));
        Object.assign(
          this.respuesta_empleado[this.editedIndex],
          this.editedItem
        );
      } else {
        this.$http
          .post("respuestas.add", datos)
          .then((response) => {
            this.initialize();
          })
          .catch((error) => console.log(error));

        this.respuesta_empleado.push(this.editedItem);
      }
      this.close();
    },
  },
};
</script>
